import { defaultTheme } from "matsuri-ui"

export const theme = {
    ...defaultTheme,
    palette: {
        ...defaultTheme.palette,
        intentions: {
            primary: {
                light: "#C8F2FA",
                main: "#03B3D2",
                dark: "#008BAD",
                contrastText: "#fff"
            },
            secondary: {
                light: "#FFCCD4",
                main: "#F96565",
                dark: "#C74646",
                contrastText: "#fff"
            },
            accent: {
                light: "#CCD9DC",
                main: "#007B8D"
            },
            text: {
                primary: "#2E3A57"
            },
            cleanerGray: {
                light: "#e6f0f2",
                main: "#ccd9dc",
                dark: "#4e757e"
            },
            cleanerBackground: {
                main: "#f7fafb"
            }
        }
    },
    device: {
        // 想定される、アプリケーションの最大幅
        maxWidth: 540
    },

    typography: {
        body: {
            // フォントサイズの変更、デフォルトは14px
            fontSize: 16
        }
    }
}
